import cn from 'classnames';
// Context
import { useFiltersContext } from 'components/common3/PageWithFiltersWrapper/PageWithFiltersContext';
// Components
import FilterItem from '../FilterItem/FilterItem';
// Styles
import styles from './WatchTypePills.module.scss';

export const WATCH_TYPE_VALUES = ['all', 'ppv', 'interviews'] as const;
export type WatchTypeValue = typeof WATCH_TYPE_VALUES[number];

const WATCH_TYPE_OPTIONS: { value: WatchTypeValue; label: string }[] = [
  { value: 'all', label: 'All Streams' },
  { value: 'ppv', label: 'PPV' },
  { value: 'interviews', label: 'Interviews' },
];

/** Value used when "Interviews" pill is selected (e.g. to hide price filter). */
export const WATCH_TYPE_INTERVIEWS: WatchTypeValue =
  WATCH_TYPE_OPTIONS[2].value;

type WatchTypePillsProps = {
  inModal?: boolean;
};

export const WatchTypePills = ({ inModal = false }: WatchTypePillsProps) => {
  const { filters, setFilters } = useFiltersContext();
  const selected = (filters?.watchType?.[0] as WatchTypeValue) || 'all';

  const onPillClick = (value: WatchTypeValue) => {
    setFilters({
      ...filters,
      watchType: value === 'all' ? [] : [value],
    });
  };

  return (
    <FilterItem title="Type" className={styles.root} isOpen={!inModal}>
      <div className={styles.pills} role="group" aria-label="Stream type">
        {WATCH_TYPE_OPTIONS.map(({ value, label }) => (
          <button
            key={value}
            type="button"
            className={cn(styles.pill, {
              [styles.pillSelected]: selected === value,
            })}
            onClick={() => onPillClick(value)}
            aria-pressed={selected === value}
          >
            {label}
          </button>
        ))}
      </div>
    </FilterItem>
  );
};

export default WatchTypePills;
